<ion-content>
    <ion-searchbar autocomplete="off" autocorrect="off"
                   placeholder="{{ 'category.search' | translate}}"
                   [value]="categorySearch"
                   [formControl]="categorySearchControl">
    </ion-searchbar>
    <ion-list #itemList>
        <ion-item *ngIf="topName" lines="full">
            <ion-icon slot="start" name="arrow-back" (click)="selectPrevCat()"></ion-icon>
            <ion-label class="selectName" (click)="selectPrevCat()">{{topName}}</ion-label>
        </ion-item>
        <div *ngFor="let catItem of categoryList">
            <ion-item *ngIf="getName(catItem)">
                <ion-label class="selectName" (click)="selectCat(catItem)">{{ getName(catItem) }}</ion-label>
                <ion-icon *ngIf="(canUsePartial || catItem.children==0) && !selectedCategory.isSame(catItem)"
                          slot="end" [ngClass]="{'unCheckedIcon': true, 'partialIcon': canUsePartial}"
                          name="radio-button-off" (click)="selectCat(catItem)"></ion-icon>
                <ion-icon *ngIf="(canUsePartial || catItem.children==0) && selectedCategory.isSame(catItem)"
                          slot="end" [ngClass]="{'checkedIcon': true, 'partialIcon': canUsePartial}"
                          name="checkmark-circle-outline" (click)="selectCat(catItem)"></ion-icon>
                <div class="nextIcon" slot="end">
                    <ion-icon *ngIf="catItem.children>0" name="arrow-forward" class="nextIcon"
                              (click)="selectNextCat(catItem)"></ion-icon>
                </div>
            </ion-item>
        </div>
        <ion-item *ngIf="!categoryList || (0===categoryList.length)">
            {{ 'category.nothing' | translate}}
        </ion-item>
    </ion-list>
</ion-content>
